import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SURVEYS } from '@/api/endpoints';
import {
  SURVEYS_QUERY_KEY,
  USER_UNSEEN_EVENTS_QUERY_KEY,
} from '@/api/queryKeys';
import { useRefreshProfiles } from '@/hooks/useRefreshProfiles';
import { ErrorMessage, logRequestError } from '@/utils/errors';
import { joinPath } from '@/utils/global';

export const useMarkSurveySeen = () => {
  const queryClient = useQueryClient();
  const refreshProfiles = useRefreshProfiles();

  const { mutate: markSeen } = useMutation({
    mutationFn: (surveyId: string) =>
      apiClient.post(`${joinPath(API_SURVEYS, surveyId)}/seen`),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: SURVEYS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: USER_UNSEEN_EVENTS_QUERY_KEY });
      await refreshProfiles();
    },
    onError: (error) => logRequestError(ErrorMessage.MarkSurveySeen, error),
  });

  return { markSeen };
};
